import { Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { SizeNotifierService } from '@shared/services/size-notifier.service';

/**
 * This directive is used to notify the service of the height of the element it is attached to.
 * This directive is specific to the browser layout component
 */
@Directive({
  selector: '[appSizeNotifier]'
})
export class SizeNotifierDirective implements OnInit, OnDestroy {
  private resizeObserver: ResizeObserver;

  constructor(
    private readonly el: ElementRef,
    private readonly sizeNotifierService: SizeNotifierService
  ) {}

  ngOnDestroy(): void {
    this.resizeObserver.disconnect();
  }

  ngOnInit(): void {
    //init the resizer
    this.resizeObserver = new ResizeObserver(entries => {
      //get the height of the element
      const itemHeight = entries[0]?.borderBoxSize[0].blockSize;
      //notify the service
      this.sizeNotifierService.elementHeight = itemHeight;
    });

    //attach the observer to the element
    this.resizeObserver.observe(this.el.nativeElement);
  }
}
